var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1430105497"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40415",
    width: 31,
    height: 31,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.9 15.4989H6.89953L6.90047 15.5086L6.90054 15.5093L6.90929 15.5997H7.00008H7.72352H7.82352V15.4997C7.82352 11.2949 11.2056 7.88006 15.3939 7.82261H15.5004C17.659 7.82261 19.6643 8.71399 21.1038 10.2494L20.3979 11.027L20.2696 11.1682L20.4588 11.1933L22.9993 11.5304L23.1374 11.5487L23.1105 11.4119L22.6034 8.83495L22.565 8.63969L22.4313 8.78705L21.7246 9.56571C20.117 7.8811 17.8871 6.9 15.5011 6.9H15.4011V6.9013C10.6945 6.95485 6.9 10.7838 6.9 15.4989ZM8.25679 21.4579L8.25681 21.458L8.39657 22.1651L8.43512 22.3602L8.56872 22.213L9.27544 21.4343C10.8837 23.1196 13.1137 24.1 15.4996 24.1H15.5996V24.098C20.3055 24.0444 24.1 20.2154 24.1 15.5003V15.4003H24H23.2766H23.1766V15.5003C23.1766 19.7068 19.7906 23.1232 15.5989 23.1768V23.176H15.4989C13.3403 23.176 11.335 22.2846 9.8955 20.7492L10.6015 19.9716L10.7297 19.8303L10.5406 19.8052L8.00009 19.4682L7.86192 19.4499L7.88881 19.5866L8.25679 21.4579Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.2dc9e311127787308197919a48d77462.svg";
export { ForwardRef as ReactComponent };